"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeBitmapSubset = void 0;
var Bitmap_1 = require("../Bitmap");
/**
 * Creates a subset {@link Bitmap} from a larger {@link Bitmap}, starting from the
 * top left corner X and Y and with a specified width and height.
 */
function makeBitmapSubset(source, x, y, width, height) {
    var e_1, _a;
    var result = new Bitmap_1.Bitmap(width, height);
    var imageIndex = 0;
    for (var col = 0; col < width; col++) {
        for (var row = 0; row < height; row++) {
            var rgba = _getPixelIndices(row + x, col + y, source.width);
            try {
                for (var _b = (e_1 = void 0, __values(rgba.entries())), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var _d = __read(_c.value, 2), i = _d[0], color = _d[1];
                    result.data[imageIndex + i] = source.data[color];
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            imageIndex += 4;
        }
    }
    return result;
}
exports.makeBitmapSubset = makeBitmapSubset;
/**
 * Gets the RGBA indices of a specific X Y coordinate within the data of an
 * {@link ImageData.data}
 */
function _getPixelIndices(x, y, width) {
    var r = y * (width * 4) + x * 4;
    return [r, r + 1, r + 2, r + 3];
}
//# sourceMappingURL=makeBitmapSubset.js.map